module.exports = __webpack_public_path__ + "img/StarOutlined.54a2c64b.svg";